import React, { useState } from 'react'
import { unstable_batchedUpdates } from 'react-dom'
import { FaExclamationTriangle } from 'react-icons/fa'
import styled from 'styled-components'
import { useEffect } from 'react'

const S_ErrIndicator = styled.div`
  max-width: 16px;
`

const defaultErrIndicator = ({ onMouseEnter, onMouseLeave }) => {
  return (
    <S_ErrIndicator onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <FaExclamationTriangle />
    </S_ErrIndicator>
  )
}

const S_ErrBox = styled.div`
  position: fixed;
  min-width: 100px;
  white-space: normal; /* Prevent parents like table cell from affecting this */
  max-width: 200px;
  background-color: #fff;
  box-shadow: 0 0 6px #ccc;
  z-index: 3000;
  border-left-style: solid;
  border-left-color: ${(props) => (props.color ? props.color : 'red')};
  border-left-width: 5px;
  font-size: 13px;
  .warning-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .error-title {
      font-weight: bold;
      border-bottom-style: solid;
      border-bottom-color: #ddd;
      border-bottom-width: 1px;
      padding: 10px;
      /* padding-bottom: 4px;
            padding-left: 5px; */
    }
    .error-description {
      flex-grow: 1;
      padding: 10px;
      /* padding-left: 5px;
            padding-top: 4px;
            padding-right: 5px;
            padding-bottom: 8px; */
    }
  }
`

const ErrBox = (props) => {
  let style = {}
  if (window.innerWidth - props.left <= 200) {
    style.right = props.right
  } else {
    style.left = props.left
  }

  if (window.innerHeight - props.top <= 200) {
    style.bottom = props.bottom
  } else {
    style.top = props.top
  }

  return (
    <S_ErrBox color={props.color} style={style}>
      <div className={`warning-content`}>
        <div className={`error-title`}>{props.errorTitle}</div>
        <div className={`error-description`}>{props.warning}</div>
      </div>
    </S_ErrBox>
  )
}

export const ErrorIndicator = (props) => {
  const [showErr, setShowErr] = useState(false)
  const [indicatorBox, setIndicatorBox] = useState({ top: 0, left: 0, right: 0, x: 0, width: 0, y: 0 })
  const [timeOutId, setTimeoutId] = useState(null)
  //TODO: allow passing of render function here
  const Indicator = typeof props.children == 'function' ? props.children : defaultErrIndicator

  const showErrorBox = (e) => {
    if (!showErr) {
      unstable_batchedUpdates(() => {
        setShowErr(true)
      })
    }
  }

  const scrollListener = () => {
    setShowErr(false)
  }

  useEffect(() => {
    const pageWrapper = document.getElementsByClassName('page-wrapper')[0] || document
    pageWrapper.addEventListener('scroll', scrollListener)

    return () => {
      pageWrapper.removeEventListener('scroll', scrollListener)
    }
  }, [])

  const hideErrorBox = (e) => {
    if (timeOutId) {
      clearTimeout(timeOutId)
    }
    setShowErr(false)
  }

  return (
    <>
      <Indicator
        onClickCapture={hideErrorBox}
        onMouseEnter={(e) => {
          let bounding = e.target.getBoundingClientRect()
          if (
            bounding.x - indicatorBox.x > 3 ||
            bounding.x - indicatorBox.x < -3 ||
            bounding.y - indicatorBox.y > 3 ||
            bounding.y - indicatorBox.y < -3
          ) {
            setIndicatorBox(bounding)
          }
          props.timeout ? setTimeoutId(setTimeout(() => showErrorBox(e), props.timeout)) : showErrorBox(e)
        }}
        onMouseLeave={hideErrorBox}
      />
      {showErr && (
        <ErrBox
          bottom={window.innerHeight - indicatorBox.y + 3}
          color={props.color}
          errorTitle={props.errorTitle}
          left={indicatorBox.x + indicatorBox.width + 3}
          right={window.innerWidth - indicatorBox.x - 1}
          top={indicatorBox.y}
          warning={props.error}
        />
      )}
    </>
  )
}
